import axios from "axios";

const submitOnboardingRequest = async (formData) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}fuel-vendor/onboarding-requests/`,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      },
    );
    return res;
  } catch (e) {
    console.error("Onboarding request submit error:", e);
    return e?.response || e;
  }
};

export { submitOnboardingRequest };
